import { render, staticRenderFns } from "./HomeRightNotif.vue?vue&type=template&id=713dc3de&scoped=true&"
import script from "./HomeRightNotif.vue?vue&type=script&lang=js&"
export * from "./HomeRightNotif.vue?vue&type=script&lang=js&"
import style0 from "./HomeRightNotif.vue?vue&type=style&index=0&id=713dc3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713dc3de",
  null
  
)

export default component.exports